<template>
	<div class="personal layout__box">
		<!-- Table -->
		<table class="basic-table personal__basic-table">

			<!-- Row -->
			<tr class="basic-table__row hr" v-for="worker in personal">
				<td class="basic-table__cell personal__img-cell">
					<div class="basic-table__avatar-wrap personal__img-wrap">
						<user-avatar :data="worker.user" :set-class="'basic-table__avatar'"></user-avatar>
					</div>
				</td>

				<td class="basic-table__cell personal__name">
					{{worker.user.last_name}} {{worker.user.first_name}} {{worker.user.middle_name}}
				</td>

				<td class="basic-table__cell personal__position">
					{{worker.position}}
				</td>

				<td class="basic-table__cell personal__link">
					<router-link :to="{name: 'Profile', params: {profile: worker._id}}" class="basic-table__link">Детали
					</router-link>
				</td>
			</tr>
			<!-- Row End -->

		</table>
		<!-- Table End -->
	</div>
</template>

<script>
	import _ from 'underscore'

	export default {
		name: 'Personal',
		computed: {
			clinicId() {
				return this.$route.params.clinic
			}
		},
		mounted() {
			this.$event.connect('userModalResponse', () => {
				this.getStaffs(this.clinicId)
			})

			this.getStaffs(this.clinicId)
		},
		beforeDestroy() {
			this.$event.disconnect(['userModalResponse'])
		},
		data() {
			return {
				personal: []
			}
		},
		methods: {
			getStaffs(id) {
				this.$store.dispatch('worker/list', {
					per_page: 100,
					current_page: 1,
					clinic_id: id
				}).then(list => {
					this.personal = list.data.filter(worker => +worker.blocked !== 1)
				})
			},
			openAddStaffModal() {
				this.$event.send('openStaffModal', {})
			},
			goToDetails(id) {
				this.$router.push({
					path: 'profile',
					query: {
						doctor: id,
						clinic: this.$route.query.clinic
					}
				})
			},
			removeStaff(id) {
				this.$api.delete('worker/' + id).then(() => {
					let index = _(this.personal).findIndex(item => item._id === id)
					this.personal.splice(index, 1)
				})
			}
		}
	}
</script>



// WEBPACK FOOTER //
// Personal.vue?514a4346